var map = {
	"./field.png": 95432,
	"./goal.png": 68955,
	"./goal_2.png": 24220,
	"./player.png": 68745,
	"./player_2.png": 87890,
	"./referee.png": 96456,
	"./trophy.png": 60184,
	"./winner.png": 25803
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 43693;